let marker_complete = ( function( $ ) {

	let $confirm_box,
		anim_speed = 400;

	let _init = function() {
		$confirm_box = $( '#confirm-completion' );

		if ( $confirm_box.length > 0 && ! $confirm_box.hasClass( 'completed' ) ) {
			_setup_handlers();
		}
	};

	let _setup_handlers = function() {
		$confirm_box.find( 'a.confirm-completion-button' ).on( 'click', function( e ) {
			e.preventDefault();
			_complete_marking();
		} );

		$( document ).on( 'completed_marking', _completed_marking );
		$( document ).on( 'failed_completing_marking', _completed_marking );
	};

	let _complete_marking = function() {
		let data = {
			action: 'crate_marker_complete',
			nonce: ScriptData.crate_marker_complete_nonce,
		};

		$.post( ScriptData.ajaxurl, data, _complete_response );
	};

	let _complete_response = function( response ) {
		if ( response.success ) {
			$( document ).trigger( 'completed_marking' );
		} else {
			$( document ).trigger( 'failed_completing_marking' );
		}
	};

	let _completed_marking = function() {
		console.log( $confirm_box.find( 'a.confirm-completion-button' ).data( 'redirect' ) );

		window.location.href = $confirm_box.find( 'a.confirm-completion-button' ).data( 'redirect' );
	};

	let _failed_completing_marking = function() {
		if ( $( '#marker-archive .error-completing-marking' ).length > 0 ) {
			$( '#marker-archive .error-completing-marking' ).fadeOut( 100 ).fadeIn( 200 );
		} else {

			let $notice = $( '<div class="error-completing-marking" style="display: none">' +
				'There was an error completing your marking. Please ensure that all proposals have been graded.' +
			'</div>' );

			$( '#marker-archive' ).prepend( $notice );

			$notice.slideDown( anim_speed );

			setTimeout( function() {
				$notice.addClass( 'shown' );
			}, anim_speed )
		}

		$( 'html, body' ).animate( { scrollTop: $( '#marker-archive .error-completing-marking' ).offset().top }, anim_speed );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = marker_complete;